<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <app-loading [condition]="isLoading.record"></app-loading>
    @if (!isLoading.record) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Record info
        </h4>
        <div class="card-body">
          <app-record [record]="record" [clients]="clients"></app-record>
        </div>
      </div>
    }
  </div>

</div>
